import axios from 'axios';
import { S3_Attachment } from '@/schema/attachment';

export interface ReferenceDataProcessFileRequest {
	participant: string;
	legal_entity?: string;
	reference_data_type: string;
	key: string;
	data: S3_Attachment;
	persist_data: boolean;
	encoding: string;
	delimiter: string;
}

export function referenceDataProcessFile(payload: ReferenceDataProcessFileRequest) {
	const body = {
		participant: payload.participant,
		legal_entity: payload.legal_entity,
		reference_data_type: payload.reference_data_type,
		key: payload.key,
		data: {
			scheme: payload.data.scheme,
			name: payload.data.name,
			bucket: payload.data.bucket,
			key: payload.data.key
		},
		persist_data: payload.persist_data,
		encoding: payload.encoding,
		delimiter: payload.delimiter
	};
	return axios.post(
		`https://${process.env.VUE_APP_API_ENDPOINT}/reference-data/process-file`,
		body,
		{ headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` } }
	);
}
